import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=0e456de7&scoped=true&"
import script from "./assignment.vue?vue&type=script&lang=ts&"
export * from "./assignment.vue?vue&type=script&lang=ts&"
import style0 from "./assignment.vue?vue&type=style&index=0&id=0e456de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e456de7",
  null
  
)

export default component.exports